import { Component, h, Prop, State } from '@stencil/core';
import { AmountControlValues, ComponentView } from '../../../types/types';
import { t } from '../../../redux/utils';

@Component({
  tag: 'rentware-amount-control',
  styleUrl: 'style.sass',
  shadow: false,
})
export class RentwareAmountControl {
  @Prop() view: ComponentView = ComponentView.Cart;
  @Prop() controlValues: AmountControlValues;
  @State() currentItemValue: string;

  componentWillUpdate() {
    if (this.controlValues.itemAmount < this.controlValues.minAmount && this.controlValues.itemAmount !== 0) {
      this.controlValues.itemAmount = this.controlValues.minAmount;
    } else if (this.controlValues.itemAmount > this.controlValues.maxAmount && this.controlValues.maxAmount > 0) {
      this.controlValues.itemAmount = this.controlValues.maxAmount;
    }
  }

  handleValidateKey = e => {
    if (!Number.isInteger(+e.key) || (+e.key === 0 && this.view === ComponentView.Search)) {
      e.preventDefault();
    }
  };

  handleInputChange = e => {
    if (+e.target.value === 0) {
      this.controlValues.deleteArticleCallback();
    } else {
      if (+e.target.value < this.controlValues.minAmount) {
        e.target.value = this.controlValues.minAmount;
        if (this.controlValues.itemAmount !== this.controlValues.minAmount) {
          this.controlValues.changeAmountCallback(this.controlValues.minAmount, this.controlValues.itemAmount);
        }
      } else if (+e.target.value > this.controlValues.maxAmount) {
        e.target.value = this.controlValues.maxAmount;
        if (this.controlValues.itemAmount !== this.controlValues.maxAmount) {
          this.controlValues.changeAmountCallback(this.controlValues.maxAmount, this.controlValues.itemAmount);
        }
      } else {
        this.controlValues.changeAmountCallback(+e.target.value, this.controlValues.itemAmount);
      }
    }
  };

  handleIncreaseValue = difference => {
    this.controlValues.changeAmountCallback(this.controlValues.itemAmount + difference, this.controlValues.itemAmount);
  };

  render() {
    if (this.view === ComponentView.Item) {
      return (
        <rentware-amount-control-item-template
          controlValues={this.controlValues}
          onIncreaseValue={this.handleIncreaseValue}
          onValidateKey={this.handleValidateKey}
          onInputChange={this.handleInputChange}
        />
      );
    }

    if (this.view === ComponentView.Cart) {
      return (
        <rentware-amount-control-cart-template
          controlValues={this.controlValues}
          onIncreaseValue={this.handleIncreaseValue}
          onValidateKey={this.handleValidateKey}
          onInputChange={this.handleInputChange}
        />
      );
    }

    if (this.view === ComponentView.Search) {
      return (
        <rentware-amount-control-search-template
          controlValues={this.controlValues}
          onIncreaseValue={this.handleIncreaseValue}
          onValidateKey={this.handleValidateKey}
          onInputChange={this.handleInputChange}
          label={t('accessibility.amountOfPersons')}
        />
      );
    }

    if (this.view === ComponentView.Booking) {
      return (
        <rentware-amount-control-booking-template
          controlValues={this.controlValues}
          onIncreaseValue={this.handleIncreaseValue}
          onValidateKey={this.handleValidateKey}
          onInputChange={this.handleInputChange}
          itemInCart={true}
        />
      );
    }

    if (this.view === ComponentView.BookingCTA) {
      return (
        <rentware-amount-control-booking-template
          controlValues={this.controlValues}
          onIncreaseValue={this.handleIncreaseValue}
          onValidateKey={this.handleValidateKey}
          onInputChange={this.handleInputChange}
        />
      );
    }

    if (this.view === ComponentView.Details) {
      return (
        <rentware-amount-control-details-template
          controlValues={this.controlValues}
          onIncreaseValue={this.handleIncreaseValue}
          onValidateKey={this.handleValidateKey}
          onInputChange={this.handleInputChange}
        />
      );
    }
  }
}
